var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import http, { Q, Api } from "@http";
import { observable, action, runInAction, computed } from "mobx";
import moment from "moment";
import { WOStatus, ScheduleType, ScheduleEntryType } from "@common/enums/base";
import { getUrlParams } from "@common/utils/url";
var EmailToScheduleStore = /** @class */ (function () {
    function EmailToScheduleStore() {
        var _this = this;
        this.currentWOIndex = 0;
        this.selectedSchedule = null;
        this.woList = [];
        this.isRecommendLoading = false;
        this.isPageLoading = false;
        this.isScheduleSuccess = true;
        this.noRecommonedChecked = false;
        this.weathers = [];
        this.scheduleRecommonedList = [];
        this.scheduleRecommoned = {};
        this.copilotLink = "";
        this.isPushOut = false;
        this.isNoRecommend = false;
        this.set = function (key, value) {
            // @ts-ignore
            _this[key] = value;
        };
    }
    Object.defineProperty(EmailToScheduleStore.prototype, "pendingWoList", {
        get: function () {
            return this.woList.filter(function (wo) { return wo.statusId === WOStatus.PendingSchedule; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmailToScheduleStore.prototype, "allScheduleWoList", {
        get: function () {
            return this.woList.filter(function (x) { return x.statusId === WOStatus.Scheduled; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmailToScheduleStore.prototype, "allPendingScheduleAndScheduleWoList", {
        get: function () {
            var _a;
            return (_a = this.pendingWoList).concat.apply(_a, this.allScheduleWoList);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmailToScheduleStore.prototype, "displayCurrentIndex", {
        get: function () {
            return this.allScheduleWoList.length + this.currentWOIndex + 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmailToScheduleStore.prototype, "displayTotal", {
        get: function () {
            return this.allPendingScheduleAndScheduleWoList.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmailToScheduleStore.prototype, "isShowMessage", {
        get: function () {
            var pullInRecommend = this.scheduleRecommoned.pullInRecommend;
            if (pullInRecommend && pullInRecommend.recommends && pullInRecommend.recommends.length) {
                var hasVisit = pullInRecommend.recommends[0].visitId;
                var noPushOut = !this.scheduleRecommoned.pushOutRecommend;
                if (hasVisit && noPushOut) {
                    return true;
                }
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmailToScheduleStore.prototype, "isExistVisit", {
        get: function () {
            if (!this.scheduleRecommoned) {
                return false;
            }
            var pushOutRecommend = this.scheduleRecommoned.pushOutRecommend;
            if (pushOutRecommend) {
                return true;
            }
            var pullInRecommend = this.scheduleRecommoned.pullInRecommend;
            if (pullInRecommend && pullInRecommend.recommends && pullInRecommend.recommends.length) {
                var top3 = this.scheduleRecommoned.pullInRecommend.topRecommends;
                var hasTechnician = top3.length > 0;
                if (!hasTechnician)
                    return false;
                var hasVisit = top3[0].visitId > 0;
                if (!hasVisit && hasTechnician) {
                    return false;
                }
                return true;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmailToScheduleStore.prototype, "isEgentWo", {
        get: function () {
            if (!this.scheduleRecommoned) {
                return false;
            }
            var pushOutRecommend = this.scheduleRecommoned.pushOutRecommend;
            var pullInRecommend = this.scheduleRecommoned.pullInRecommend;
            if (!pullInRecommend || !pullInRecommend.recommends) {
                return false;
            }
            if (pushOutRecommend || pullInRecommend.topRecommends.length === 1 && pullInRecommend.recommends.length <= 0) {
                return true;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    EmailToScheduleStore.prototype.setSelectedSchedule = function (schdule) {
        this.selectedSchedule = schdule;
    };
    EmailToScheduleStore.prototype.getCopilotLink = function () {
        return __awaiter(this, void 0, void 0, function () {
            var link;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getCopilotLink(this.getKey())];
                    case 1:
                        link = _a.sent();
                        runInAction(function () {
                            _this.copilotLink = link;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    EmailToScheduleStore.prototype.getWOList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var promise, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isPageLoading = true;
                        promise = this.api().getWOList(this.getKey());
                        return [4 /*yield*/, promise];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.woList = data;
                            _this.isPageLoading = false;
                        });
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    EmailToScheduleStore.prototype.getWoRecommendTechnicians = function () {
        return __awaiter(this, void 0, void 0, function () {
            var wo, param, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        wo = this.pendingWoList[this.currentWOIndex];
                        if (!wo) {
                            console.error("no wo");
                            return [2 /*return*/];
                        }
                        param = {
                            serviceCodeId: wo.serviceCodeId,
                            priorityId: wo.priorityId,
                            locationId: wo.locationId,
                            canScheduleInWeekend: false,
                            startTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
                        };
                        this.isRecommendLoading = true;
                        return [4 /*yield*/, this.api().getAutoScheduleData(this.getKey(), param)];
                    case 1:
                        data = _a.sent();
                        this.getWeatherForecastByTime();
                        runInAction(function () {
                            _this.scheduleRecommoned = data;
                            _this.isRecommendLoading = false;
                            _this.populateRecommend(data);
                            if (data.pushOutRecommend) {
                                _this.selectedSchedule = data.pushOutRecommend;
                                _this.isPushOut = true;
                            }
                            else {
                                _this.isPushOut = false;
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    EmailToScheduleStore.prototype.populateRecommend = function (data) {
        var topRecommend = data.pullInRecommend.topRecommends;
        if (!topRecommend || topRecommend.length <= 0) {
            this.isNoRecommend = true;
        }
        else {
            this.isNoRecommend = false;
        }
    };
    EmailToScheduleStore.prototype.getKey = function () {
        var key = getUrlParams().key.split('?')[0];
        if (!key) {
            return console.error("not key.");
        }
        return key;
    };
    EmailToScheduleStore.prototype.reset = function () {
        this.isScheduleSuccess = true;
        this.currentWOIndex = 0;
        this.isPageLoading = false;
    };
    EmailToScheduleStore.prototype.schedule = function (wo) {
        return __awaiter(this, void 0, void 0, function () {
            var woId, scheduleModel, scheduleResult_1, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isPageLoading = true;
                        this.isScheduleSuccess = false;
                        woId = wo && wo.woId;
                        scheduleModel = {
                            key: this.getKey(),
                            scheduleResult: __assign(__assign({}, this.selectedSchedule), { isSelectPushOutTechnician: this.isPushOut })
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api().schedule(this.getKey(), woId, scheduleModel)];
                    case 2:
                        scheduleResult_1 = _a.sent();
                        this.scheduleRecommendTrack(woId);
                        runInAction(function () {
                            _this.isScheduleSuccess = scheduleResult_1 <= 1;
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        runInAction(function () {
                            _this.isScheduleSuccess = false;
                            console.warn(error_1);
                        });
                        return [3 /*break*/, 4];
                    case 4:
                        runInAction(function () {
                            _this.isPageLoading = false;
                        });
                        return [2 /*return*/, this.isScheduleSuccess];
                }
            });
        });
    };
    EmailToScheduleStore.prototype.getWeatherForecastByTime = function () {
        return __awaiter(this, void 0, void 0, function () {
            var dates, totalDays, day, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.weathers && this.weathers.length > 0) {
                            return [2 /*return*/];
                        }
                        dates = [];
                        totalDays = 16;
                        day = -1;
                        do {
                            dates.push(moment
                                .utc()
                                .add(day, 'day')
                                .format('YYYY-MM-DD'));
                            day = day + 1;
                        } while (day < totalDays);
                        return [4 /*yield*/, this.api().getWeatherForecastByTime(dates)];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.weathers = data;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    EmailToScheduleStore.prototype.getWeatherByTime = function (date) {
        return (this.weathers.find(function (weather) {
            return moment.utc(weather.date).format('YYYY-MM-DD') ===
                moment(date).format('YYYY-MM-DD');
        }) || {});
    };
    Object.defineProperty(EmailToScheduleStore.prototype, "scheduleTimeBlocks", {
        get: function () {
            var scheduleData = this.scheduleRecommoned;
            if (!(scheduleData && scheduleData.pullInRecommend)) {
                return [];
            }
            scheduleData.pullInRecommend.topRecommends.map(function (x) {
                x.isRecommend = true;
            });
            scheduleData.pullInRecommend.recommends.map(function (x) {
                x.isRecommend = false;
            });
            var result = Array();
            if (scheduleData.pushOutRecommend) {
                if (scheduleData.pushOutRecommend) {
                    result = [scheduleData.pushOutRecommend];
                }
            }
            else {
                result = __spreadArrays(scheduleData.pullInRecommend.topRecommends, scheduleData.pullInRecommend.recommends);
            }
            return result;
        },
        enumerable: false,
        configurable: true
    });
    EmailToScheduleStore.prototype.resendEmail = function (key) {
        return this.api().resendEmail(key);
    };
    EmailToScheduleStore.prototype.scheduleRecommendTrack = function (woId) {
        var _a = this.scheduleRecommoned.pullInRecommend, pullInRecommend = _a === void 0 ? {} : _a;
        this.api().scheduleRecommendTrack({
            refId: woId,
            refType: ScheduleType.ReactiveWO,
            scheduleEntryType: ScheduleEntryType.MessageSchedule,
            trackData: pullInRecommend.trackData,
            trackOption: this.selectedSchedule
        });
    };
    EmailToScheduleStore.prototype.api = function () {
        return {
            getCopilotLink: function (token) {
                return Q(http.get("/ResidentScheduleOptimization/copilot-link?token=" + token));
            },
            getWOList: function (key) {
                return Q(http.get("/ResidentSchedule/" + key + "/WoList"));
            },
            schedule: function (key, woId, params) {
                return Q(http.put("/ResidentSchedule/" + key + "/ScheduleWorkOrder", __assign({ key: key, woId: woId }, params)));
            },
            getAutoScheduleData: function (key, params) { return Q(http.get("/ResidentSchedule/" + key + "/WorkOrderRecommendTechnicians", {
                params: __assign({ key: key }, params)
            })); },
            getWeatherForecastByTime: function (dates) {
                return Q(http.post('RSP/NewRequest/GetWeatherForecastByTime', { times: dates }, Api.withForm));
            },
            resendEmail: function (key) {
                if (location.hash.includes("ResidentScheduleOptimization")) {
                    return Q(http.put("ResidentScheduleOptimization/ResetMail?token=" + key));
                }
                return Q(http.put("ResidentSchedule/" + key + "/ResetMail"));
            },
            scheduleRecommendTrack: function (params) {
                return Q(http.post("/Track/schedule", params));
            }
        };
    };
    __decorate([
        observable
    ], EmailToScheduleStore.prototype, "currentWOIndex", void 0);
    __decorate([
        observable
    ], EmailToScheduleStore.prototype, "selectedSchedule", void 0);
    __decorate([
        observable
    ], EmailToScheduleStore.prototype, "woList", void 0);
    __decorate([
        computed
    ], EmailToScheduleStore.prototype, "pendingWoList", null);
    __decorate([
        computed
    ], EmailToScheduleStore.prototype, "allScheduleWoList", null);
    __decorate([
        computed
    ], EmailToScheduleStore.prototype, "allPendingScheduleAndScheduleWoList", null);
    __decorate([
        computed
    ], EmailToScheduleStore.prototype, "displayCurrentIndex", null);
    __decorate([
        computed
    ], EmailToScheduleStore.prototype, "displayTotal", null);
    __decorate([
        observable
    ], EmailToScheduleStore.prototype, "isRecommendLoading", void 0);
    __decorate([
        observable
    ], EmailToScheduleStore.prototype, "isPageLoading", void 0);
    __decorate([
        observable
    ], EmailToScheduleStore.prototype, "isScheduleSuccess", void 0);
    __decorate([
        observable
    ], EmailToScheduleStore.prototype, "noRecommonedChecked", void 0);
    __decorate([
        observable
    ], EmailToScheduleStore.prototype, "weathers", void 0);
    __decorate([
        observable
    ], EmailToScheduleStore.prototype, "scheduleRecommonedList", void 0);
    __decorate([
        observable
    ], EmailToScheduleStore.prototype, "scheduleRecommoned", void 0);
    __decorate([
        observable
    ], EmailToScheduleStore.prototype, "copilotLink", void 0);
    __decorate([
        computed
    ], EmailToScheduleStore.prototype, "isShowMessage", null);
    __decorate([
        computed
    ], EmailToScheduleStore.prototype, "isExistVisit", null);
    __decorate([
        computed
    ], EmailToScheduleStore.prototype, "isEgentWo", null);
    __decorate([
        action
    ], EmailToScheduleStore.prototype, "setSelectedSchedule", null);
    __decorate([
        action
    ], EmailToScheduleStore.prototype, "getCopilotLink", null);
    __decorate([
        action
    ], EmailToScheduleStore.prototype, "getWOList", null);
    __decorate([
        observable
    ], EmailToScheduleStore.prototype, "isPushOut", void 0);
    __decorate([
        observable
    ], EmailToScheduleStore.prototype, "isNoRecommend", void 0);
    __decorate([
        action.bound
    ], EmailToScheduleStore.prototype, "getWoRecommendTechnicians", null);
    __decorate([
        action.bound
    ], EmailToScheduleStore.prototype, "reset", null);
    __decorate([
        action.bound
    ], EmailToScheduleStore.prototype, "schedule", null);
    __decorate([
        action
    ], EmailToScheduleStore.prototype, "getWeatherForecastByTime", null);
    __decorate([
        action.bound
    ], EmailToScheduleStore.prototype, "set", void 0);
    __decorate([
        computed
    ], EmailToScheduleStore.prototype, "scheduleTimeBlocks", null);
    __decorate([
        action.bound
    ], EmailToScheduleStore.prototype, "resendEmail", null);
    __decorate([
        action
    ], EmailToScheduleStore.prototype, "scheduleRecommendTrack", null);
    return EmailToScheduleStore;
}());
export default EmailToScheduleStore;
